import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Tabs as MuiTabs, Tab } from '@material-ui/core';
import LabelWithBadge from './components/LabelWithBadge';

import useStyles from './useStyles';

const Tabs = props => {
  const { currentTabIndex, onChange, allTabsBadgeCount, waitlistTabsBadgeCount, tabIndexValues } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  const [first, second] = tabIndexValues;

  return (
    <div>
      <MuiTabs
        value={currentTabIndex}
        onChange={onChange}
        indicatorColor="primary"
        textColor="primary"
        className={classes.tabs}
      >
        <Tab
          label={
            <LabelWithBadge label={t('components.RealEstateAgentLoanOfficers.Tabs.allTab')} count={allTabsBadgeCount} />
          }
          value={first}
          className={classes.tab}
        />
        <Tab
          label={
            <LabelWithBadge
              label={t('components.RealEstateAgentLoanOfficers.Tabs.waitlistTab')}
              count={waitlistTabsBadgeCount}
            />
          }
          value={second}
          className={classes.tab}
        />
      </MuiTabs>
    </div>
  );
};

Tabs.propTypes = {
  currentTabIndex: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  tabIndexValues: PropTypes.arrayOf(PropTypes.number).isRequired,
  allTabsBadgeCount: PropTypes.number,
  waitlistTabsBadgeCount: PropTypes.number,
};

Tabs.defaultProps = {
  allTabsBadgeCount: null,
  waitlistTabsBadgeCount: null,
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentLoanOfficers/components/Tabs/Tabs.js